//--------------------------------------------------
// imported classes
//--------------------------------------------------
const EventDispatcher = require('../event/EventDispatcher')
const ClassFunc = require('./ClassFunc')

/**
 *	The tbs.util.FlowProcessor class works as event flow processor
 * to handle the serial processing work.
 */
const tbs_util_FlowProcessor = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, EventDispatcher, arguments);

    //--------------------------------------------------
    // private properties
    //--------------------------------------------------
    let _step = 0;
    let _flow = [];
    let _current;
    let _name;
    let _completeSignal;

    //--------------------------------------------------
    // privileged setter and getter
    //--------------------------------------------------
    this.p_step = function(value) {
        if (arguments.length > 0) {
            _step = value;
        }
        else {
            return _step;
        }
    };

    this.p_flow = function(value) {
        if (arguments.length > 0) {
            _flow = value;
        }
        else {
            return _flow;
        }
    };

    this.p_current = function(value) {
        if (arguments.length > 0) {
            _current = value;
        }
        else {
            return _current;
        }
    };

    this.p_name = function(value) {
        if (arguments.length > 0) {
            _name = value;
        }
        else {
            return _name;
        }
    };

    this.p_completeSignal = function(value) {
        if (arguments.length > 0) {
            _completeSignal = value;
        }
        else {
            return _completeSignal;
        }
    }
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_util_FlowProcessor.prototype = {
    EVENT: "event",
    FUNC: "func",
    //--------------------------------------------------
    // static api
    //--------------------------------------------------
    regRules: function(rulesName, completeSignal) {
        if (this.p_name()) {
            return false;
        }
        else {
            this.p_name(rulesName);
            this.p_completeSignal(completeSignal);
            return true;
        }
    },
    regEvent: function(type, data, isInsert) {
        const flow = this.p_flow();
        if (isInsert) {
            // insert the event
            flow.unshift({type: this.EVENT, event: type, data: data});
        }
        else {
            // append the event
            flow.push({type: this.EVENT, event: type, data: data});
        }
        return this;
    },
    regFunc: function(func, param, scope, isInsert) {
        const flow = this.p_flow();
        if (isInsert) {
            // insert the event
            flow.unshift({type: this.FUNC, func: func, param: param, scope: scope});
        }
        else {
            flow.push({type: this.FUNC, func: func, param: param, scope: scope});
        }
        return this;
    },
    launch: function() {
        const flow = this.p_flow();
        let step = this.p_step();
        // console.log("launch", flow, step);
        if (flow && flow.length > 0) {
            let item = flow.shift();
            // console.log("item", item);
            this.p_current(item);
            // update the inner step value
            this.p_step(++step);
            if (item.type == this.EVENT) {
                this.dispatchEvent({type: item.event, data: item.data, target: this});
            }
            else if (item.type == this.FUNC) {
                return ClassFunc.applyFunctionOnLibrary(item.scope, item.func, item.param);
            }	
        }
        else {
            this.escapeRules();
        }
    },
    escapeRules: function() {
        const completeSignal = this.p_completeSignal();
        if (completeSignal) {
            if (completeSignal.event) {
                this.dispatchEvent({type: completeSignal.event, data: completeSignal.data});
            }
            if (completeSignal.callback) {
                completeSignal.callback(completeSignal.data);
            }
        }
        
        this.p_name(null);
        this.p_completeSignal(null);
        this.p_flow([]);
        this.p_step(0);
    },
    current: function() {
        return this.p_current();
    },
    progress: function() {
        return {
            total: this.p_step() + this.p_flow().length,
            current: this.p_step()
        };
    },
    name: function() {
        return this.p_name();
    }
}

//--------------------------------------------------
// extends the EventDispatcher
//--------------------------------------------------
ClassFunc.extend(tbs_util_FlowProcessor, EventDispatcher);

module.exports = tbs_util_FlowProcessor;